"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType["ShortUrlError"] = "ShortUrlError";
    MessageType["LongUrlError"] = "LongUrlError";
    MessageType["FileUploadError"] = "FileUploadError";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
